import { Flex } from "@chakra-ui/react"
import { EntityId } from "@jackfruit/common"
import React from "react"
import CloudImageBrowser from "../../common/browser/CloudImageBrowser"
import CloudImageBrowserActionsMobile from "../../common/browser/CloudImageBrowserActionsMobile"
import CloudImageBrowserLoader from "../../common/browser/CloudImageBrowserLoader"
import VNZImageSelector from "./VNZImageSelector"

interface Props {
  isLoading: boolean
  imageIds: EntityId[]
  selectedImageIds: EntityId[]
  handleImageSelect: (id: EntityId) => void
  isImportingImages: boolean
  hasSelectedImages: boolean
  handleUploadImages: () => void
}

const VNZImageBrowserMobile: React.FC<Props> = ({
  isLoading,
  imageIds,
  selectedImageIds,
  handleImageSelect,
  handleUploadImages,
  hasSelectedImages,
  isImportingImages,
}) => {
  return (
    <Flex flexDirection="column" flex={1} minH={0} overflow="hidden">
      {/* flex child with minH=0 gives Virtuoso a definite height to scroll within;
          overflow hidden clips the non-scrolling loading skeleton. */}
      <Flex flex={1} minH={0} px={4} overflow="hidden">
        {isLoading && <CloudImageBrowserLoader />}
        {!isLoading && (
          <CloudImageBrowser
            imageIds={imageIds}
            onImageSelect={handleImageSelect}
            selectedImageIds={selectedImageIds}
            imageComponent={VNZImageSelector}
          />
        )}
      </Flex>
      <CloudImageBrowserActionsMobile
        selectedImageIds={selectedImageIds}
        isImportingImages={isImportingImages}
        hasSelectedImages={hasSelectedImages}
        handleUploadImages={handleUploadImages}
      />
    </Flex>
  )
}

export default VNZImageBrowserMobile
